var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import styles from './components/globals/globals.module.scss';
export var matchClassName = function (className, selector) {
    if (typeof selector === 'boolean')
        return className;
    if (Array.isArray(selector)) {
        return className;
    }
    var classParams = ("" + selector).split(/[ .]+/).join('-');
    return styles[className + "-" + classParams];
};
export var flatten = function (array) {
    return array.reduce(function (flat, toFlatten) {
        return flat.concat(Array.isArray(toFlatten) ? flatten(toFlatten) : toFlatten);
    }, []);
};
export var classNames = function (classNames) {
    if (classNames === void 0) { classNames = []; }
    var joinedNames = [];
    if (Array.isArray(classNames)) {
        for (var _i = 0, _a = flatten(classNames); _i < _a.length; _i++) {
            var className = _a[_i];
            if (typeof className === 'string') {
                joinedNames.push(className);
            }
            if (typeof className === 'object') {
                for (var _b = 0, _c = Object.keys(className); _b < _c.length; _b++) {
                    var key = _c[_b];
                    if (className[key]) {
                        joinedNames.push(key);
                    }
                }
            }
        }
    }
    if (!Array.isArray(classNames) && typeof classNames === 'object') {
        for (var _d = 0, _e = Object.keys(classNames); _d < _e.length; _d++) {
            var key = _e[_d];
            if (classNames[key]) {
                joinedNames.push(key);
            }
        }
    }
    return joinedNames.filter(Boolean).join(' ');
};
export var filterProps = function (allProps) {
    if (allProps === void 0) { allProps = {}; }
    return Object.keys(allProps).reduce(function (acc, key) {
        var _a;
        var value = allProps[key];
        if (value) {
            var name_1 = matchClassName(key, value);
            if (!name_1)
                return acc;
            return __assign(__assign({}, acc), (_a = {}, _a[name_1] = true, _a));
        }
        return acc;
    }, {});
};
export var toKebabCase = function (string) {
    return (string &&
        string
            .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
            .map(function (x) { return x.toLowerCase(); })
            .join('-'));
};
//# sourceMappingURL=utils.js.map